import { useEffect, useState } from 'react';
import { isEmpty } from 'lodash';

import { apiUser } from 'utilities/http/api/apiUser';
import { notify } from 'utilities/notifications/notify';
import { UserCapabilitiesTypes } from 'types';

function useUserCapabilities() {
  const [capabilities, setCapabilities] = useState<UserCapabilitiesTypes[]>([]);
  const [loadingCapabilities, setLoadingCapabilities] = useState(true);

  useEffect(() => {
    if (!isEmpty(capabilities)) {
      setLoadingCapabilities(false);
      return;
    }

    const fetch = async () => {
      setLoadingCapabilities(true);
      try {
        const response = await apiUser.getCapabilities();
        setCapabilities(response.json.capabilities);
      } catch (e) {
        notify.error('Error fetching user capabilities');
      } finally {
        setLoadingCapabilities(false);
      }
    };

    fetch();
  }, []);

  return { capabilities, loadingCapabilities };
}

export default useUserCapabilities;
